import { render, staticRenderFns } from "./QuotaFlow.vue?vue&type=template&id=9d278c76&scoped=true"
import script from "./QuotaFlow.vue?vue&type=script&lang=js"
export * from "./QuotaFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d278c76",
  null
  
)

export default component.exports